import { StaticImage } from "gatsby-plugin-image";
import * as React from "react";

const UpdateImage = () => (<StaticImage src="../../images/update.png" alt="Update image" />);
export default UpdateImage;
